import { useAppSelector } from '@verantos-dev/app-state-base';
import {
  selectViewedCohortBuilderItems,
  selectCohortDefinition,
  selectModal,
} from '@verantos-dev/app-state-cohort-builder';
import {
  CohortBuilderItemChangeStatusLegacy,
  CohortBuilderModalLegacy,
} from '@verantos-dev/types-cohorts';

export const useResearchAssistantTabbedArea = () => {
  const viewedCohortBuilderItems = useAppSelector(selectViewedCohortBuilderItems);
  const cohortDefinition = useAppSelector(selectCohortDefinition);
  const modal = useAppSelector(selectModal);

  let itemsToReviewCount = 0;
  cohortDefinition?.derivedEvents.forEach((event) => {
    if (
      event.changeStatus &&
      event.changeStatus !== CohortBuilderItemChangeStatusLegacy.UNCHANGED &&
      !viewedCohortBuilderItems?.[event.id]
    ) {
      itemsToReviewCount += 1;
    }
  });
  cohortDefinition?.simpleEvents.forEach((event) => {
    if (
      event.changeStatus &&
      event.changeStatus !== CohortBuilderItemChangeStatusLegacy.UNCHANGED &&
      !viewedCohortBuilderItems?.[event.id]
    ) {
      itemsToReviewCount += 1;
    }
  });
  cohortDefinition?.subjectVariables.forEach((variable) => {
    if (
      variable.changeStatus &&
      variable.changeStatus !== CohortBuilderItemChangeStatusLegacy.UNCHANGED &&
      !viewedCohortBuilderItems?.[variable.id]
    ) {
      itemsToReviewCount += 1;
    }
  });
  if (
    cohortDefinition?.indexDate &&
    cohortDefinition.indexDate.changeStatus &&
    cohortDefinition.indexDate.changeStatus !== CohortBuilderItemChangeStatusLegacy.UNCHANGED &&
    !viewedCohortBuilderItems?.[cohortDefinition.indexDate.id]
  ) {
    itemsToReviewCount += 1;
  }

  const showSimpleEventEditModal =
    modal !== undefined &&
    [
      CohortBuilderModalLegacy.ADD_SIMPLE_EVENT,
      CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT,
    ].includes(modal);
  const showDerivedEventEditModal =
    modal !== undefined &&
    [
      CohortBuilderModalLegacy.ADD_DERIVED_EVENT,
      CohortBuilderModalLegacy.EDIT_DERIVED_EVENT,
    ].includes(modal);
  const showIndexDate =
    modal !== undefined &&
    [CohortBuilderModalLegacy.ADD_INDEX_DATE, CohortBuilderModalLegacy.EDIT_INDEX_DATE].includes(
      modal
    );
  const showSubjectVariableEditModal =
    modal !== undefined &&
    [
      CohortBuilderModalLegacy.ADD_SUBJECT_VARIABLE,
      CohortBuilderModalLegacy.EDIT_SUBJECT_VARIABLE,
    ].includes(modal);
  const showStudyPeriodEditModal =
    modal !== undefined && modal === CohortBuilderModalLegacy.CONFIGURE_STUDY_PERIOD;

  return {
    cohortDefinition,
    itemsToReviewCount: undefined,
    showSimpleEventEditModal,
    showDerivedEventEditModal,
    showIndexDate,
    showSubjectVariableEditModal,
    showStudyPeriodEditModal,
  };
};
